import React, { useEffect, useRef } from 'react';
import ResizableField from '../../../utility/resizableField';
import _ from 'lodash';
import { GridYValue } from '../../../constants';
import Select from 'react-select';
import cx from 'classnames';

export const DropdownElement = function FromElement({ element, setPosition, innerElemHeight }) {
  const inputRef = useRef();

  const handlerWidthChange = (shift) => {
    var formAreaWidth = document.getElementsByClassName('form-area')[0].offsetWidth;

    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        width: Math.max(
          5,
          Math.min(100 - prevPosition.left, Math.floor((((prevPosition.startWidth / 100) * formAreaWidth + shift) / formAreaWidth) * 100)),
        ),
      };
    });
  };

  const finishWidthChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startWidth: prevPosition.width,
      };
    });
  };

  const handlerHeightChange = (shift) => {
    setPosition((prevPosition) => {
      const diff = Math.floor(shift / GridYValue);

      return {
        ...prevPosition,
        height: Math.max(11, prevPosition.startHeight + diff),
        innerElemHeight: Math.max(3, prevPosition.startInnerElemHeight + diff),
      };
    });
  };

  const finishHeightChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startHeight: prevPosition.height,
        startInnerElemHeight: prevPosition.innerElemHeight,
      };
    });
  };

  useEffect(() => {
    if (inputRef.current?.controlRef) {
      ResizableField(inputRef.current.controlRef, handlerWidthChange, finishWidthChange, handlerHeightChange, finishHeightChange);
    }
  }, [inputRef, element, element.options.width]);

  return (
    <div
      className={cx('form-element-flex-label-wrapper', {
        labelPlacementLeft: element.options.labelPlacement === 'left',
      })}
    >
      <label htmlFor={element.id} className="form-label">
        {element.options.label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
      </label>
      <Select
        classNamePrefix="react-select"
        name={element.options.name}
        id={element.id}
        ref={inputRef}
        styles={{
          width: '100%',
          control: (styles) => ({
            ...styles,
            height: innerElemHeight,
            minHeight: 'unset !important',
            width: '100% !important',
          }),
          container: (styles) => ({
            ...styles,
            height: innerElemHeight,
          }),
          menu: (styles) => ({
            ...styles,
            minWidth: 'unset',
          }),
        }}
        className={`form-control-select d-flex input-resizable-wrapper flex-wrap`}
        options={element.inputs.map((item) => ({ label: item.label, value: item.id }))}
      />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </div>
  );
};
